import { columnTypes } from "@/services/Grid/ColumnTypes";

export const teamUserGridColumnTypes = columnTypes;

export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
};

export const gridColumns = [
  {
    headerName: 'Name',
    field: 'name',
  },
  {
    headerName: 'Last Login',
    field: 'lastLoginDate',
    type: 'dateTimeColumn',
  },
  {
    headerName: '# Assigned',
    field: 'assigned',
    hide: true,
  },
  {
    headerName: '# Completed',
    field: 'completed',
    hide: true,
  },
  {
    headerName: '# Overdue',
    field: 'overdue',
    hide: true,
  },
];
